module.exports = require('./FileUploadView');
